module.exports = require('./FileUploadView');
